/* eslint-disable react-hooks/exhaustive-deps */
import * as wjcCore from "@grapecity/wijmo"
import * as wjcInput from "@grapecity/wijmo.input"
import * as WjRInput from "@grapecity/wijmo.react.input"

import React, { useEffect, useRef, useState } from "react"

type TYearInput = {
  className?: string
  autoFocus?: boolean
  id?: string
  isRequired?: boolean
  isReadOnly?: boolean
  placeholder?: string
  isDisabled?: boolean
  value: number | null | undefined
  setValue: (value: number | null | undefined) => unknown
}

const YearInput: React.FC<TYearInput> = ({
  className,
  autoFocus,
  setValue,
  value,
  id,
  isRequired = false,
  isReadOnly,
  placeholder,
  isDisabled,
}) => {
  const target = useRef(null)
  const [classNameInner, setClassNameInner] = useState("")

  // placeHolderとfloatinglabel用
  const [innerText, setInnerText] = useState<string>()
  const [isShowFloatingLabel, setIsShowFloatingLabel] = useState<boolean>()

  useEffect(() => {
    if (placeholder && innerText != null && innerText !== "" && value != null) {
      setIsShowFloatingLabel(true)
    } else {
      setIsShowFloatingLabel(false)
    }
  }, [innerText, placeholder, value])

  // classあて
  useEffect(() => {
    const classNameArray: string[] = []
    isRequired && classNameArray.push("required_input")
    className && classNameArray.push(className)
    if (classNameArray.length > 0) {
      setClassNameInner(classNameArray.join(" "))
    } else {
      setClassNameInner("")
    }
  }, [isRequired, className])

  return (
    <div ref={target} className="floating-frame">
      {isShowFloatingLabel && (
        <span className="floating-label">{placeholder}</span>
      )}
      <div style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
        <WjRInput.InputNumber
          id={id}
          format="d"
          className={classNameInner}
          isRequired={isRequired}
          isReadOnly={isReadOnly}
          value={value}
          min={1900}
          max={9999}
          step={1}
          showSpinner={true}
          placeholder={isShowFloatingLabel ? "" : placeholder ?? ""}
          isDisabled={isDisabled}
          valueChanged={(s: wjcInput.InputNumber, e: wjcCore.EventArgs) => {
            if (isRequired && s.value == null) {
              wjcCore.toggleClass(s.hostElement, "is-error", true)
            } else {
              wjcCore.toggleClass(s.hostElement, "is-error", false)
              setValue(s.value)
            }
          }}
          textChanged={(control: wjcInput.InputNumber) => {
            setInnerText(control.text)
          }}
          initialized={(control: wjcInput.InputNumber) => {
            if (autoFocus) control.inputElement?.focus()
          }}
        />
        <span>年</span>
      </div>
    </div>
  )
}

export default YearInput
